import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './NewPasswordReset.css';

const NewPasswordReset = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: '',
    });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setMessage(null);

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match.');
            setLoading(false);
            return;
        }

        try {
            const response = await fetch('https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/Users/resetpassword/confirm', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token,
                    newPassword: formData.password,
                    confirmPassword: formData.confirmPassword
                }),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                setMessage('Password successfully reset!');
                setFormData({ password: '', confirmPassword: '' });
                setTimeout(() => navigate('/login'), 3000); // Redirect to login after success
            } else {
                setError(data.message || 'Failed to reset password.');
            }
        } catch (err) {
            console.error('Error resetting password:', err);
            setError('An error occurred. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="new-password-reset-ship-container">
            <h2>Reset Your Password</h2>
            {message && (
                <div
                    style={{
                        color: 'green',
                        backgroundColor: '#DFF2BF',
                        padding: '10px',
                        borderRadius: '5px',
                        border: '1px solid #4CAF50',
                        marginBottom: '20px',
                    }}
                >
                    {message}
                </div>
            )}
            {error && (
                <div
                    style={{
                        color: '#721C24',
                        backgroundColor: '#F8D7DA',
                        padding: '10px',
                        borderRadius: '5px',
                        border: '1px solid #F5C6CB',
                        marginBottom: '20px',
                    }}
                >
                    {error}
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <div className="new-password-reset-form-group">
                    <label>New Password</label>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="new-password-reset-form-group">
                    <label>Confirm Password</label>
                    <input
                        type="password"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        required
                    />
                </div>
                <button type="submit" className="new-password-reset-submit-btn" disabled={loading}>
                    {loading ? 'Resetting Password...' : 'Reset Password'}
                </button>
            </form>
        </div>
    );
};

export default NewPasswordReset;
